const Q = require(`q`);
const __request = require(`../../../../../../common-project/lib/data-service/haolv-default/__request/__request_contentType_json`);

const get_emun_selector_List = (pParameter) => {
    if (!pParameter) pParameter = {};
    const url = pParameter.request_url || '';
    const p = {
        method: 'post',
        urlSuffix: url,
        data: {},
    };
    return Q.when()
        .then(function () {
            return __request(p);
        })
        .then(function (data) {
            return Q.resolve(data);
        })
        .catch(function (ex) {
            console.error(ex);
            if (ex) {
                if (ex.stack) {
                    console.error(ex.stack);
                }
            }
            return Q.reject(ex);
        })
        ;
};
module.exports = get_emun_selector_List;
